import CardProduct from './CardProduct'
export default CardProduct
